import React, { useEffect, useRef } from 'react'
import './cover.css'
import CV from '../../assets/cv.pdf'
import { init } from 'ityped'
import Aos from 'aos';
import 'aos/dist/aos.css';


const Cover = () => {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  return (
    <section id='home' className='home'>
        <div className='container__grid'>
            <div className='container__left'>
                <h3 data-aos="fade-down">WELCOME TO MY WEBSITE</h3>
                <h1 data-aos="fade-down">Hi, I'm <span>Luis Meléndez</span></h1>
                <h2 data-aos="fade-down"> a
                    <span>
                     {" "} Frontend Developer.
                    </span>
                </h2>
                <p data-aos="fade-down"> I am a graduate of the Systems Engineering and Computer Science degree, with more than 1 year of experience in Frontend development, using the React js library.  
                I have creative capacity, teamwork and ease of adaptation to changes, always predisposed 
                to collaborate, learn and continue my professional and academic training.
                </p>
                <div data-aos="fade-up" className='hero__btn'>
                    <div className='col_1'>
                        <h4>MY CV</h4>
                            <div className='button'>
                                <a className='a_shadow btn__download' href={CV} target='_blank'>
                                   Download 
                                </a>
                            </div>
                    </div>

                    <div className='col_1'>
                        <h4>FIND WITH ME</h4>
                        <div className='button'>
                            <a className='a_shadow a_margin'  href='https://github.com/lumerocode' target='_blank'>
                                <i className='fab fa-github fa-lg'/>
                            </a >
                            <a className='a_shadow a_margin' href='https://www.linkedin.com/in/lumerocode/' target='_blank'>
                                <i className='fab fa-linkedin-in'/>
                            </a>
                            <a className='a_shadow a_margin' href='https://twitter.com/lumerocode' target='_blank'>
                                <i className='fab fa-twitter'/>
                            </a>
                            <a className='a_shadow' href='https://codepen.io/LuisMR27' target='_blank'>
                                <i className='fab fa-codepen'/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div data-aos="zoom-in" className='container__right'>
                <div className='right__img'>
                </div>
            </div>
            
        </div>
    </section>
  )
}

export default Cover